import "./styles.scss";

import { ReactComponent as BasicIcon } from "assets/icons/basic-plan.svg";
import { ReactComponent as PremiumIcon } from "assets/icons/premium-plan.svg";
import { ReactComponent as EcommerceIcon } from "assets/icons/ecommerce-plan.svg";

const PlanTag = ({ name, label = name }) => {
  return (
    <span className="plan-tag">
      <span>
        {(() => {
          switch (name) {
            case "Safety":
              return <BasicIcon />;
            case "Basic":
              return <PremiumIcon />;
            case "Premium":
            case "Premium / E-commerce":
              return <EcommerceIcon />;
            default:
              return null;
          }
        })()}
      </span>
      {label}
    </span>
  );
};

export default PlanTag;
